import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Icons from "../../../../Config/Images";
import { addToCartAPI, getCartAPI } from "../../../../Store/Action/cartAction";
import {
  addWishlistAPI,
  removeWishlistAPI,
} from "../../../../Store/Action/wishlistAction";
import DeleteModal from "../../Auth/MyAccount/CustomModals/DeleteModal";
import "./styles.css";
import CustomImageComponent from "../../CustomComponents/CustomImageComponent";
import ConfirmationPopup from "../../CustomComponents/ConfirmationPopup";
import { useMediaQuery } from "@mui/material";
import {
  removeFromCart,
  updateCartItemQuantity,
} from "../../../../Store/Slice/cartSlice";
import {
  setCartItemCount,
  triggerCartChange,
} from "../../../../Store/Slice/popupTriggerSlice";
import VariantSelectionPopup from "../../CustomComponents/VariantSelectionPopup";
import { getProductDetailsAPI } from "../../../../Store/Action/productAction";

const LeftSideCart = ({
  imageSrc,
  productName,
  productCode,
  netWeight,
  wastage,
  product,
  onClick,
  onGetWishlist,
  cartFlag,
  fine,
  getCartRefresh,
  refreshTotalAmount,
  userRole,
  isWastageEnabled,
}) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);

  // const [isWastageEnabled, SetIsWastageEnabled] = useState(true);
  const [quantity, setQuantity] = useState(product?.cart_quantity);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [isConfirmationPopupOpen, setIsConfirmationPopupOpen] = useState(false);
  const [isVariantPopupOpen, setIsVariantPopupOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  useEffect(() => {
    setQuantity(product?.cart_quantity);
  }, [product?.cart_quantity]);

  const handleOpenVariantPopup = (prod) => {
    const params = {
      product_id: prod?.product_id,
    };
    dispatch(
      getProductDetailsAPI(params, (result) => {
        setIsVariantPopupOpen(true);
        setSelectedProduct(result.data[0]);
      }),
    );
  };

  const handleUpdateQty = (product, action) => {
    let currentQty = Number(quantity);
    // let currentQty = Number(product?.cart_quantity);

    if (action == "isIncrement") {
      currentQty += 1;
    } else if (action === "isDecrement") {
      currentQty -= 1;
    }

    const payload = {
      product_id: product.product_id,
      quantity: currentQty,
    };

    dispatch(
      addToCartAPI(payload, (result) => {
        if (result?.status) {
          dispatch(
            updateCartItemQuantity({
              productId: product?.product_id,
              quantity: result?.data?.[0]?.product_quantity,
            }),
          );
          // dispatch(triggerCartChange());
          dispatch(
            getCartAPI({}, (result) => {
              const cartLength = result?.total_count;
              dispatch(setCartItemCount(cartLength));
            }),
          );
          setQuantity(
            result.data?.[0]?.cart_quantity || product?.cart_quantity,
          );
          getCartRefresh();
          // refreshTotalAmount();
          dispatch(triggerCartChange());

          // toast.success(result?.message?.message);
        } else {
          toast.error(result?.error?.message);
        }
      }),
    );
  };

  const handleDeleteItem = (product) => {
    setItemToDelete(product);
    setIsModalOpen(true);
  };

  const handleMoveToWishlist = (product) => {
    setItemToDelete(product);
    setIsConfirmationPopupOpen(true);
  };

  const onClose = useCallback(() => {
    setIsConfirmationPopupOpen(false);
    setIsModalOpen(false);
  }, []);

  const handleMoveToCart = (product) => () => {
    const quantityIncrement = user?.user_role_id === 5 ? 25 : 1;
    const cartData = {
      product_id: product.product_id,
      wishlist_id: product?.wishlist_id,
      product_quantity: quantityIncrement,
    };
    dispatch(
      addToCartAPI(cartData, (result) => {
        if (result?.status) {
          onGetWishlist();
          toast.success("Product moved to cart!");
        } else {
          toast.error("Failed to add product to cart.");
        }
      }),
    );
  };

  const handleConfirmDelete = () => {
    if (cartFlag) {
      const cartData = {
        product_id: itemToDelete?.product_id,
        flag_deleted: true,
      };
      dispatch(
        addToCartAPI(cartData, (result) => {
          if (result?.status) {
            dispatch(removeFromCart(itemToDelete.product_id));
            dispatch(triggerCartChange());
            dispatch(
              getCartAPI({}, (result) => {
                const cartLength = result?.total_count;
                dispatch(setCartItemCount(cartLength));
              }),
            );
            onGetWishlist();
            // toast.success("Item removed from cart successfully.");
            // setQuantity(0);
          } else {
            toast.error(
              result?.error?.message || "Failed to remove item from cart.",
            );
          }
        }),
      );
    } else {
      dispatch(
        removeWishlistAPI(itemToDelete.wishlist_id, (result) => {
          if (result?.status) {
            onGetWishlist();
            toast.success("Item removed from wishlist successfully.");
          } else {
            toast.error(
              result?.error?.message || "Failed to remove item from wishlist.",
            );
          }
        }),
      );
    }
    setIsModalOpen(false);
  };

  const handleYesAPICall = useCallback(() => {
    // Extract all variant IDs
    // Filter variants that belong to the same cart_id
    const selectedVariants =
      itemToDelete.product_variants?.filter((v) => v.cart_id) || [];

    // Extract IDs
    const variantIds = selectedVariants.map((v) => v.product_variant_id);
    const requestWishlistData = {
      product_id: itemToDelete?.product_id,
      // product_variant_id: variantIds,
      flag_move_to_wishlist: true,
    };

    dispatch(
      addWishlistAPI(requestWishlistData, (isSuccess, result) => {
        if (result?.status) {
          onClose();
          onGetWishlist();
          // toast.success(result?.message?.message);
        } else {
          onClose();
          toast.error(result?.message?.message);
        }
      }),
    );
  }, [dispatch, itemToDelete?.product_id, onClose, onGetWishlist]);

  return (
    <div className="cart-full-width-div">
      <div className="cart-main-card" style={{ borderRadius: 6 }}>
        {/* Product Image */}
        <div onClick={onClick} className="left-side-image">
          <CustomImageComponent
            // width="100%"
            width={"130px"}
            // height="100%"
            style={{ objectFit: "cover" }}
            src={imageSrc}
          />
        </div>

        {/* Product Details */}
        <div className="right-side-content">
          <p className="prod-name">{productName}</p>
          {/* <p className="p">Brand: {product?.brand_name}</p> */}
          {product?.product_category_type_name.toLowerCase() === "product" ? (
            <>
              {/* <p className="p">Code: {productCode}</p> */}
              <p className="p">
                Net Weight: {product?.product_avg_net_weight} g
              </p>

              <p className="p">
                Stamp : {product?.product_stamp_value} (
                {product?.product_melting_value})
              </p>

              {(isWastageEnabled && product?.mode_name === "Wastage") ||
              product?.is_labour_enabled ? (
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  {isWastageEnabled && product?.mode_name === "Wastage" && (
                    <p className="p">Wastage: {wastage || "-"}</p>
                  )}

                  {isWastageEnabled &&
                    product?.mode_name === "Wastage" &&
                    product?.is_labour_enabled && (
                      <div className="vertical-line"></div>
                    )}

                  {product?.is_labour_enabled && (
                    <p className="p">
                      Labour
                      {product?.labour_type_code
                        ? ` (${product.labour_type_code})`
                        : ""}
                      : {product?.product_labour || "-"}
                    </p>
                  )}
                </div>
              ) : null}
            </>
          ) : (
            <>
              <p className="p"> Code : {productCode}</p>

              <p className="light-text-cart-divv p">
                Per Pc Rate : {product?.product_per_pc_rate}
              </p>

              <p className="light-text-cart-fine-divv p">
                Category : {product?.product_category_name}
              </p>
            </>
          )}

          <div className="cart-actions">
            <div>
              {product?.product_category_type_name?.toLowerCase() ===
              "per pc product" ? (
                // Show + - buttons ONLY for Per Pc Products
                cartFlag ? (
                  <div className="quantity-buttons">
                    <img
                      src={Icons.minusCircleIcon}
                      alt="Decrease Quantity"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleUpdateQty(product, "isDecrement");
                      }}
                    />
                    <span className="quantity-text">{quantity}</span>
                    <img
                      src={Icons.addCircleIcon}
                      alt="Increase Quantity"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleUpdateQty(product, "isIncrement");
                      }}
                    />
                  </div>
                ) : (
                  <button
                    className="move-to-cart"
                    onClick={handleMoveToCart(product)}
                  >
                    Move to Cart
                  </button>
                )
              ) : (
                <div className="quantity-buttons">
                  <img
                    src={Icons.minusCircleIcon}
                    alt="Decrease Quantity"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenVariantPopup(product);
                    }}
                  />
                  <span className="quantity-text">{quantity}</span>
                  <img
                    src={Icons.addCircleIcon}
                    alt="Increase Quantity"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenVariantPopup(product);
                    }}
                  />
                </div>
              )}
            </div>

            <div className="vertical-line"></div>
            {/* delete button  */}
            <div
              className="remove-with-text"
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteItem(product);
              }}
              style={{ cursor: "pointer" }}
            >
              <img
                src={Icons.trashIcon}
                alt="Delete"
                className="delete-cart-icon"
              />
              <span className="remove-text">Remove</span>
            </div>

            <div className="vertical-line"></div>
            {/* move to wishlist button  */}
            <div
              className="remove-with-text"
              onClick={(e) => {
                e.stopPropagation();
                // handleDeleteItem(product);
              }}
            >
              <img
                src={Icons.moveWishlistIcon}
                alt="icon"
                onClick={(e) => {
                  e.stopPropagation();
                  handleMoveToWishlist(product);
                }}
                style={{ width: "26px", height: "22px" }}
                className="move-to-wishlist-icon"
              />
              <span
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleMoveToWishlist(product);
                }}
                className="move-to-wishlist-text"
              >
                Move to Wishlist
              </span>
            </div>
            {/* </div> */}
          </div>
        </div>
      </div>

      {/* Delete Modal */}
      {isModalOpen && (
        <DeleteModal
          onClose={() => setIsModalOpen(false)}
          onDelete={handleConfirmDelete}
        />
      )}

      {isConfirmationPopupOpen && (
        <ConfirmationPopup
          onClose={onClose}
          onYesClick={handleYesAPICall}
          title={"Are you sure you want to Move this item?"}
        />
      )}

      {isVariantPopupOpen && (
        <VariantSelectionPopup
          open={isVariantPopupOpen}
          product={selectedProduct}
          onClose={() => setIsVariantPopupOpen(false)}
          onSubmit={(selectedIds) => {
            const request = {
              product_id: selectedProduct.product_id,
              product_variant_id: selectedIds,
            };

            dispatch(
              addToCartAPI(request, (result) => {
                if (result?.status) {
                  setIsVariantPopupOpen(false);
                  dispatch(triggerCartChange());
                }
              }),
            );
          }}
          mode="variant"
        />
      )}
    </div>
  );
};

export default React.memo(LeftSideCart);
